import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react';
import { RichText, Image } from '@sitecore-jss/sitecore-jss-react';

import { throttle, isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions";

import '../../assets/css/0020_objects/0870_obj_hero_banner_comptoir_dermato.css'

class ObjBannerHeroComptoirDermato extends Component {
	constructor() {
		super()
		this.state = {
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

	render() {
        if(!this.props.dataBanners || !this.props.dataBanners[0]) return null;
        const dataBanner = this.props.dataBanners[0];
		
		return (
			<section className={`obj_section obj_hero_banner_comptoir_dermato ${' var_' + dataBanner.align.value} ${dataBanner.darkMode.boolValue ? ' var_dark' : ''}`}>
				<div className="ctn_section">
					<div className="ctn_text">
                        {/* banner type text : CAFTextBanner */}
                        { dataBanner.template.id === "31C956382BE1472095B3E8D7A9E8C60D" && dataBanner.content.jss && 
                            <RichText tag="h1" className="t_title" field={dataBanner.content.jss} /> 
                        }
					</div>
				</div>
				<picture className="ctn_background">
                    <source srcSet={dataBanner.imageMobile.jss.value.src} media="(max-width:767px)"/>
                    <Image field={dataBanner.image.jss}></Image>
				</picture>
			</section>
        )
	}
}

export default withTranslation()(withSitecoreContext()(ObjBannerHeroComptoirDermato));